import { render, staticRenderFns } from "./MealsModal.vue?vue&type=template&id=fc36eb6e&"
import script from "./MealsModal.vue?vue&type=script&lang=js&"
export * from "./MealsModal.vue?vue&type=script&lang=js&"
import style0 from "./MealsModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports